import { gql } from '@apollo/client/core';

export const loadUserClaims = gql`
  query loadUserClaims {
    loadUserClaims {
      id
      name
    }
  }
`;
